var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurityScorecard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0145 15.5L28.3008 16.5033L25.7247 17.997L28.3008 19.5018L30.0145 20.494L34.3044 23.002V17.997L30.0145 15.5Z",
    fill: "#6641F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 12L19.7101 14.497V19.5021L22.2862 17.9972L23.9999 17.0051L28.3008 14.497L23.9999 12Z",
    fill: "#6641F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6956 17.997V23.002L15.4093 23.9941L17.9854 25.499V15.5L13.6956 17.997Z",
    fill: "#6641F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7101 28.4982L13.6956 24.998V30.0031L17.9854 32.5001L19.7101 31.4968L22.2862 30.0031L19.7101 28.4982Z",
    fill: "#6641F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7247 30.0029L23.9999 30.995L19.7101 33.5031L23.9999 36.0001L28.3008 33.5031V28.498L25.7247 30.0029Z",
    fill: "#6641F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5906 23.9937L30.0145 22.5V32.4991L34.3044 30.0021V24.997L32.5906 23.9937Z",
    fill: "#6641F3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1448 27.7506L28.3008 26.5021V21.497L23.9999 19L19.7101 21.497V26.5021L23.9999 28.9991L26.1448 27.7506Z",
    fill: "#6641F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityScorecard);
export default __webpack_public_path__ + "static/media/SecurityScorecard.d50da3df180be5dc95616ca784df51d1.svg";
export { ForwardRef as ReactComponent };